import { FC, SVGProps } from 'react'

export const ArrowLeft: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.7621 18.5206C10.4746 18.8188 9.99979 18.8274 9.70162 18.5399L3.4794 12.5399C3.33281 12.3985 3.25 12.2036 3.25 12C3.25 11.7964 3.33281 11.6015 3.4794 11.4601L9.70162 5.46012C9.99979 5.1726 10.4746 5.18123 10.7621 5.4794C11.0496 5.77757 11.041 6.25236 10.7428 6.53988L5.85826 11.25L20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75L5.85826 12.75L10.7428 17.4601C11.041 17.7476 11.0496 18.2224 10.7621 18.5206Z"
			fill="currentColor"
		/>
	</svg>
)
